import { useAsyncExecutor2 } from "async-executor-hook";
import { differenceInDays, format } from "date-fns";
import { stringify } from "query-string";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { Observable } from "rxjs";
import { WCalendar } from "../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../common/components/TemplateContainer/TemplateContainer";
import { removeNullProps } from "../../common/utils";
import AdminAppointmentConfigurationSidebar from "../AdminAppointmentConfigurationSidebar/AdminAppointmentConfigurationSidebar";
import { SecondaryButton } from "../AdminDocumentManagement/AdminDocumentManagementSharedStyles";

interface Props {
  params$: Observable<{
    date_start: any;
    date_end: any;
    page: number;
  }>;
  rangeConfirmation: () => void;
  onTitleConfirmationChange: (title: string) => void;
  onMessageConfirmationChange: (message: string) => void;
}

export const AdminAppointmentConfigurationSearch = (props: Props) => {
  const {
    params$,
    rangeConfirmation,
    onTitleConfirmationChange,
    onMessageConfirmationChange,
  } = props;
  const history = useHistory();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        date_start: new FormControl(),
        date_end: new FormControl(),
      });
      form.get("date_start").valueChanges.subscribe((date_start: Date) => {
        const dateEnd = new Date(form.get("date_end").value) || new Date();
        const diffDate = differenceInDays(dateEnd, new Date(date_start));
        if (diffDate < 1) {
          form.get("date_end").setValue(date_start);
        }
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form) => {
      const data = form.value;
      const date_start =
        data.date_start && format(data.date_start, "yyyy-MM-dd");
      const date_end = data.date_end && format(data.date_end, "yyyy-MM-dd");
      const pathname = history.location.pathname;
      history.push(
        `${pathname}?${stringify(
          removeNullProps({ ...data, date_start, date_end })
        )}`
      );
    },
  });

  useAsyncExecutor2((params) => params, {
    params$,
    onSuccess: (params) => {
      formConfig.loadSucceed(params);
    },
  });

  const [showSidebar, updateShowSidebar] = useState(false);
  return (
    <>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <div
          className="p-grid"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div className="p-col-6 p-md-3">
            <WFormControl name="date_start">
              <TemplateInputContainer label="Fecha de inicio:" color="#08082B">
                <WCalendar width="100%" dateFormat="dd/mm/yy" />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <WFormControl name="date_end">
              <TemplateInputContainer label="Fecha de fin:">
                <WCalendar
                  width="100%"
                  minDate={
                    formConfig.form?.get("date_start")?.value || new Date()
                  }
                  dateFormat="dd/mm/yy"
                />
              </TemplateInputContainer>
            </WFormControl>
          </div>
          <div className="p-col-6 p-md-3">
            <div style={{ marginBottom: "1.8rem", height: "1.4rem" }} />
            <SaveButton
              label="Consultar"
              width="100%"
              height="5rem"
              backgroundColor="#002E6C"
            />
          </div>
          <div className="p-col-6 p-md-3" style={{ marginTop: "3rem" }}>
            <SecondaryButton
              type="button"
              onClick={() => {
                onMessageConfirmationChange(
                  "Se ha configurado la planificación semanal con éxito."
                );
                onTitleConfirmationChange("Planificación semanal configurada");
                updateShowSidebar(true);
              }}
            >
              Crear rango horario
            </SecondaryButton>
          </div>
        </div>
      </WForm>
      {showSidebar && (
        <AdminAppointmentConfigurationSidebar
          rangeConfirmation={rangeConfirmation}
          onOutsideClick={() => updateShowSidebar(false)}
        />
      )}
    </>
  );
};
